@let user = this.user$() | async;
<cam-loader [isLoading]="this.requestState.isLoading()">
  <cam-error [message]="this.requestState.getErrorMessage()" [code]="this.requestState.getErrorStatus()">
    <cam-empty [isEmpty]="!user">
      @if (user) {
        <cam-card>
          <cam-card-content>
            <cam-user-profile [user]="user"></cam-user-profile>
          </cam-card-content>
        </cam-card>
      }
    </cam-empty>
  </cam-error>
</cam-loader>
